import { TUser } from "./AdminTypes";

export const selectUser = (state: RootState): TUser
    | null => {
    if (state.admin.user) {
        return state.admin.user;
    } else {
        return null
    }
};